export const AppConfigsActionDispatchTypes = {
  APP_CONFIG_INVOKE: "APP_CONFIG_INVOKE",
  APP_CONFIG_SUCCESS: "APP_CONFIG_SUCCESS",
};

export const AppEnvironmentConfig = {
  DEV: "development",
  PROD: "production",
};

export const CloudEnvironmentConfig = {
  SB1: "SB1",
  QA1: "QA1",
  DEV1: "DEV1",
  STG: "STG",
  SB2: "SB2",
  DEV2: "DEV2",
  QA2: "QA2",
};

export const Application =  "HealthPlanPortalUI";
